import { Accordion } from 'ui/svg/icons/bicolor/Accordion'
import { Book } from 'ui/svg/icons/bicolor/Book'
import { Bookstore } from 'ui/svg/icons/bicolor/Bookstore'
import { Brush } from 'ui/svg/icons/bicolor/Brush'
import { Cinema } from 'ui/svg/icons/bicolor/Cinema'
import { DanceFeet } from 'ui/svg/icons/bicolor/DanceFeet'
import { Festival } from 'ui/svg/icons/bicolor/Festival'
import { Micro } from 'ui/svg/icons/bicolor/Micro'
import { Microphone } from 'ui/svg/icons/bicolor/Microphone'
import { Museum } from 'ui/svg/icons/bicolor/Museum'
import { Music } from 'ui/svg/icons/bicolor/Music'
import { Opera } from 'ui/svg/icons/bicolor/Opera'
import { PencilTip } from 'ui/svg/icons/bicolor/PencilTip'
import { PerformingArts } from 'ui/svg/icons/bicolor/PerformingArts'
import { Piano } from 'ui/svg/icons/bicolor/Piano'
import { Press } from 'ui/svg/icons/bicolor/Press'
import { PuzzlePiece } from 'ui/svg/icons/bicolor/PuzzlePiece'
import { Show } from 'ui/svg/icons/bicolor/Show'
import { Streaming } from 'ui/svg/icons/bicolor/Streaming'
import { Theater } from 'ui/svg/icons/bicolor/Theater'
import { Video } from 'ui/svg/icons/bicolor/Video'
import { VideoGame } from 'ui/svg/icons/bicolor/VideoGame'

export const culturalSurveyIcons = {
  Accordion,
  Book,
  Bookstore,
  Brush,
  Cinema,
  DanceFeet,
  Festival,
  Micro,
  Microphone,
  Museum,
  Music,
  Opera,
  PencilTip,
  PerformingArts,
  Piano,
  Press,
  PuzzlePiece,
  Show,
  Streaming,
  Theater,
  VideoGame,
  Video,
}
